import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { BaseApiService } from './base-api.service';
import { FileModel } from '../models/file.model';

@Injectable({
  providedIn: 'root'
})
export class FileService {

  constructor(
    private api: BaseApiService,
  ) { }

  uploadImage(file: File, isPublic: boolean = false): Observable<FileModel | undefined> {
    const queryParams = { expand: 'image', public: isPublic };

    return this.api.postFormData(`/files`, { file }, queryParams).pipe(
      map(response => {
        if (response?.body?.success == false) {
          return undefined;
        }

        return new FileModel(response.body);
      }),
      catchError(() => of(undefined)),
    );
  }
}
